import http from './http.service';

class UserService {
    constructor() {
        if (UserService.instance) {
            return UserService.instance;
        }

        UserService.instance = this;
    }

    profile() {
        return http.get('/user/profile').then(res => res.data);
    }
    profileUpdate(data) {
        return http.put('/user/profile/update', data).then(res => res.data);
    }
    permissions() {
        return http.get('/user/permissions').then(res => res.data);
    }
    users() {
        return http.get('/user').then(res => res.data);
    }
    store(data) {
        return http.post('/user/store', data).then(res => res.data);
    }
    update(userId, data) {
        return http.put(`/user/${userId}/update`, data).then(res => res.data);
    }
    destroy(userId) {
        return http.delete(`/user/${userId}/destroy`).then(res => res.data);
    }
}

export default new UserService();
